import React from "react";
import userManager from "../helpers/userManager";

function UnautherizeContent() {
  return (
    <div className="app-page-not-found text-center mt-5">
      <div>
        {/* <h2 className="text-red-600 text-center">Be Warned</h2> */}
        <h2 className="text-red-600 text-center">
          Oops..! Something went wrong. Please contact administrator.
        </h2>
      </div>
      <div className="text-center mt-3">
        <button
          onClick={() => userManager.signoutRedirect()}
          className="btn btn-primary text-uppercase txtside-btn txtht-btn">
          Go To Login
        </button>
      </div>
    </div>
    //     <div className="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4" role="alert">
    //   <p className="font-bold">Be Warned</p>
    //   <p>You have no role in this site.Please contact application owner.</p>
    //      <button onClick={() => userManager.signinRedirect()} className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 border border-blue-700 rounded">
    //         Go To Login
    //      </button>
    // </div>
  );
}

export default UnautherizeContent;
